import { render, staticRenderFns } from "./VideoEnlargeTwo.vue?vue&type=template&id=8b874358&scoped=true&"
import script from "./VideoEnlargeTwo.vue?vue&type=script&lang=js&"
export * from "./VideoEnlargeTwo.vue?vue&type=script&lang=js&"
import style0 from "./VideoEnlargeTwo.vue?vue&type=style&index=0&id=8b874358&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b874358",
  null
  
)

export default component.exports